import React, {useEffect, useState} from 'react'
import "./TeamFeedback.scss"
import PersonAvatar from "../../common/PersonAvatar/PersonAvatar";

function TeamFeedback({  member }) {
    const [ currentFeedback , setCurrentFeedback ] = useState('')
    const handleOnClickQuestion = (questionAsked) => {
        setCurrentFeedback(questionAsked.a)
    }
    useEffect( () => {
            return () => {
                setCurrentFeedback('')
            }
    }, [])
    return  <>
            <div className={"team-feedback-container"} >
                <div className={"team-feedback-avatar"}>
                    <PersonAvatar avatar={member.avatar} name={member.name}  role={member.jobtitle} speak={currentFeedback}/>
                </div>
                <div className={"team-feedback-content"} >
                    {member.questions && member.questions.map( question => {
                        return <div key={question.q} className={"team-feedback-question"} onClick={() => {
                            handleOnClickQuestion(question)}
                        }>
                            {question.q || 'Oops something went wrong'}
                        </div>
                    })}
                </div>
            </div>
        </>
}
export default TeamFeedback;
